import { InjectionToken } from "@angular/core";

export const ListaMensajeProcesadorToken = new InjectionToken("ListaMensajeProcesadorToken");
